import React from 'react';
import { paginationStyles } from '../styles/sharedStyles';

const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
  totalItems = 0,
  itemsPerPage = 10,
}) => {
  const [hoveredButton, setHoveredButton] = React.useState(null);

  if (totalPages <= 1) return null;

  const getPageNumbers = () => {
    const pages = [];
    const maxPagesToShow = 5;

    if (totalPages <= maxPagesToShow) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Always show first page
      pages.push(1);

      // Calculate range around current page
      let startPage = Math.max(2, currentPage - 1);
      let endPage = Math.min(totalPages - 1, currentPage + 1);

      // Add ellipsis if needed
      if (startPage > 2) {
        pages.push('...');
      }

      // Add pages around current page
      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }

      // Add ellipsis if needed
      if (endPage < totalPages - 1) {
        pages.push('...');
      }

      // Always show last page
      pages.push(totalPages);
    }

    return pages;
  };

  const getButtonStyle = (page, isActive, isDisabled) => {
    const baseStyle = { ...paginationStyles.button };

    if (isDisabled) {
      return { ...baseStyle, ...paginationStyles.buttonDisabled };
    }

    if (isActive) {
      return { ...baseStyle, ...paginationStyles.buttonActive };
    }

    if (hoveredButton === page) {
      return { ...baseStyle, ...paginationStyles.buttonHover };
    }

    return baseStyle;
  };

  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);

  return (
    <div style={paginationStyles.container}>
      {/* Previous Button */}
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        onMouseEnter={() => setHoveredButton('prev')}
        onMouseLeave={() => setHoveredButton(null)}
        style={getButtonStyle('prev', false, currentPage === 1)}
      >
        « Previous
      </button>

      {/* Page Numbers */}
      {getPageNumbers().map((page, index) => {
        if (page === '...') {
          return (
            <span key={`ellipsis-${index}`} style={paginationStyles.info}>
              ...
            </span>
          );
        }

        return (
          <button
            key={page}
            onClick={() => onPageChange(page)}
            onMouseEnter={() => setHoveredButton(page)}
            onMouseLeave={() => setHoveredButton(null)}
            style={getButtonStyle(page, page === currentPage, false)}
          >
            {page}
          </button>
        );
      })}

      {/* Next Button */}
      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        onMouseEnter={() => setHoveredButton('next')}
        onMouseLeave={() => setHoveredButton(null)}
        style={getButtonStyle('next', false, currentPage === totalPages)}
      >
        Next »
      </button>

      {/* Info Text */}
      {totalItems > 0 && (
        <span style={paginationStyles.info}>
          Showing {startItem}-{endItem} of {totalItems}
        </span>
      )}
    </div>
  );
};

export default Pagination;
